import styled from 'styled-components';

export default styled.div`
  height: ${({ heightOfBottomcontainer }) => heightOfBottomcontainer};
  transition: height 500ms cubic-bezier(0.4, 0, 0.2, 1);
`;
